import { useEffect, useState } from "react";
import { getInvoiceDownloadUrl } from "../services/apiService";

export const RECEIPT_POLL_MS = 15 * 1000;
export const RECEIPT_MAX_ATTEMPTS = 20;

// Justificatif d'une recharge terminée (écran 1e).
//
// Le PDF est produit par Qobilling une fois la recharge facturée : en général moins
// d'une minute après l'arrêt, parfois bien plus. On ne propose le téléchargement
// qu'une fois le PDF disponible ; au-delà de quelques minutes on cesse de vérifier,
// et le client s'en tient au justificatif envoyé par e-mail.
export default function useReceiptReady({ transactionId, accessToken, enabled }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled || !transactionId) return undefined;

    let stopped = false;
    let timer = null;
    let attempts = 0;

    const checkReceipt = async () => {
      attempts += 1;
      try {
        const response = await getInvoiceDownloadUrl(transactionId, accessToken);
        if (stopped) return;

        if (response?.url) {
          setReady(true);
          return;
        }
      } catch (error) {
        // PDF pas encore généré, ou erreur passagère : on retentera au prochain passage.
      }

      if (!stopped && attempts < RECEIPT_MAX_ATTEMPTS) {
        timer = setTimeout(checkReceipt, RECEIPT_POLL_MS);
      }
    };

    checkReceipt();

    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [enabled, transactionId, accessToken]);

  return ready;
}
